"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearTilemap = void 0;
var diveTileData_1 = require("../../tilemap/diveTileData");
var diveTileData_sidecar_1 = require("../../tilemap/diveTileData-sidecar");
var diveTilemap_sidecar_1 = require("../../tilemap/diveTilemap-sidecar");
var diveTilemapPart_sidecar_1 = require("../../tilemap/diveTilemapPart-sidecar");
function clearTilemap() {
    var obj = diveTilemap_sidecar_1.diveTilemap.get();
    // let wall = diveTileData.get(EDiveTile.Wall)
    var empty = diveTileData_sidecar_1.diveTileData.get(diveTileData_1.EDiveTile.Acid);
    for (var j = 0; j < obj.height; j++) {
        for (var i = 0; i < obj.width; i++) {
            var gs = diveTilemap_sidecar_1.diveTilemap.getUnsafe(i, j);
            diveTilemapPart_sidecar_1.diveTilemapPart.setTile(gs, empty);
            // gs.flickerState = 0
            // gs.flickerTimer = 0
            gs.variant = 0;
            gs.isCentralHallway = false;
            gs.isRoom = false;
            gs.shadow = 0;
            gs.visibilityIdx = 0;
            // if (i === 0 || j === 0 || i === obj.width - 1 || j === obj.height - 1) {
            //   console.log('set wall', i, j)
            //   let gs = diveTilemap.getUnsafe(i, j)
            //   diveTilemapPart.setTile(gs, wall)
            // }
        }
    }
}
exports.clearTilemap = clearTilemap;
